<template>
    <div class="homes">
        <aboutStyle :title="langes == 0 ? '热销产品':'HOT'" v-if="hotProductList.length != 0"></aboutStyle>
        <div class="productCard" v-if="hotProductList.length != 0">
            <el-row>
                <el-col   :span="3" v-for="(o, index) in hotProductList" :key="index" :offset="index > 0 ? 4 : 0">
                    <el-card :body-style="{ padding: '0px' }" class="card">
                        <img @click="hotProductClick" :src="o.productLogo" class="imageCard">
                        <div style="padding: 14px;text-align: center;">
                            <span style="font-size:18px;">{{o.title}}</span>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="IndexCard">
            <el-container >
                <el-aside width="180px">
                    <ul v-for="(item,t) in selectList" :key="t" class="home_select">
                        <li :class="t == activeClick ? 'select enables' : 'select'" @click="selectClick(t,item)">
                             <el-image :src='item.img'
                                      style="width:50px;height:50px;"/>
                            <div class="bottom clearfix">
                                <span :class="t == activeClick ? 'contentSpan':'contentSpan-disable'">{{langes == 0 ? item.newsCategoryName:item.newsCategoryNameEn}}</span>
                            </div>
                        </li>
                    </ul>
                </el-aside>
                <el-main style="width:100%;">
                    <el-row>
                        <el-col :span="12" >
                            <div class="grid-content">
                                <el-row>
                                    <el-col :span="24" style="width:100%;height:40px;">
                                        <div class="grid-content-l">
                                            <div class="companyInfo">
                                           <span class="titleSpan">{{indexTitle}}</span>
                                           <el-divider direction="vertical"></el-divider>
                                           <span class="titleInfoSpan">{{langes == 0 ? '信息':'MESSAGE'}}</span>
                                            </div>
                                           <div class="findMore" @click="findMoreClick">{{langes == 0 ? '查看更多':'MORE'}}>></div>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <!-- 放固定的图片信息 -->
                                    <el-col :span="24" style="width:100%;height:200px;">
                                        <div class="grid-content-imge">
                                            <a :href="leftUrl" target="view_window">
                                              <el-image
                                                style="width: 100%; height: 200px"
                                                :src="leftIndexUrl"
                                                fit="fill"></el-image>
                                            </a>    
                                        </div>
                                    </el-col>
                                </el-row>
                                 <el-row>
                                    <!-- 放固定的图片信息 -->
                                    <el-col :span="24" style="width:100%;height:200px;">
                                       <ul class="indexUL" v-for="(item,index) in newList" :key="index">
                                          <li class="indexLi" @click="findMoreClick">● <div class="grid-content-l">
                                           <span class="contentSpanTitle">{{item.newsTitle | ellipsis}}</span>
                                           <div class="contentSpanTime">{{item.createTime}}</div>
                                        </div></li>
                                       </ul>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                        <el-col :span="1" ><div class="grid-content"></div></el-col>
                        <el-col :span="11">
                            <div class="grid-content">
                                <el-row>
                                    <el-col :span="24" style="width:100%;height:40px;">
                                        <div class="grid-content-l">
                                           <div class="companyInfo">
                                                <span class="titleSpan">{{company.companyName}}</span>
                                            <el-divider direction="vertical"></el-divider>
                                            <span class="titleInfoSpan">{{langes == 0 ? '品牌介绍':'BRAND'}}</span>
                                           </div>
                                           <div class="findInfo" @click="findCompanyInfoClick">{{langes == 0 ? '查看更多':'MORE'}}>></div>
                                        </div>
                                    </el-col>
                                </el-row>   
                                <el-row>
                                    <!-- 放固定的图片信息 -->
                                    <el-col :span="24" style="width:100%;height:200px;">
                                        <div class="grid-content-imge">
                                            <a :href="rightUrl" target="view_window">
                                              <el-image
                                                style="width: 100%; height: 200px"
                                                :src="rightIndexUrl"
                                                fit="fill"></el-image>
                                            </a>
                                        </div>
                                    </el-col>
                                </el-row>
                               <el-row> 
                                   <el-col :span="24" style="width:100%;height:200px;">
                                    <div class="companyInfo"> <span style="margin-top:18px;color:#333;font-size:20px;">{{langes == 0 ? '企业简介':'COMPANY'}}</span></div>
                                    <div class="content" v-html="company.companyDesc"></div>
                                   </el-col>      
                               </el-row>      
                            </div>
                        </el-col>
                    </el-row>
                </el-main>
            </el-container>
        </div>
        <aboutStyle :title="langes == 0 ? '友情链接':'FRIEND'" v-if="partnerList.length != 0"></aboutStyle>
        <div style="min-height:40px; margin-top:20px;margin-bottom:20px;">
            <el-row>
                <el-col :span="4" v-for="(it,index) in partnerList" :key="index">
                    <a :href="it.companyUrl" target="_blank">
                        <el-image style="width:100px;height:100px;" :src="imageUrl + '/' + it.companyLogo">
                        </el-image>
                        <div class="bottom clearfix">
                            <span style="color:#333">{{it.companyName}}</span>
                        </div>
                    </a>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import aboutStyle from '@/components/aboutStyle.vue';

    export default {
        components: {aboutStyle},
        name: 'Homes',
        data() {
            return {
                loading: false,
                current: 0,
                langes:0,
                activeClick:0,
                list: [{
                    name: '公司简介'
                }, {
                    name: '企业文化'
                }, {
                    name: '精英团队'
                }],
                selectList: [],
                partnerList: [],
                hotProductList: [],
                newList:[],
                imageUrl: this.$api.imageUrl,
                leftIndexUrl:"",
                leftUrl:"",
                rightIndexUrl:"",
                rightUrl:"",
                indexTitle:"",
                fitUrl:require("@/assets/qingchen2.jpg"),
                fitUrl1:require("@/assets/qingchen.jpg"),
                company:{}

            }
        },
        inject: ['parentEle'],
        created() {
            this.getNewCatetoryList();
            this.getPartnerList();
            this.getHotProductList();
            this.getCompany();
            this.getLeftImg();
            this.getRightImg();
        },
        mounted() {
            window.addEventListener('setItem', () => {
                this.langes = sessionStorage.getItem('watchStorage');
            })
        },
        filters:{
           ellipsis: function(value) {
                if (!value) return "";
                if (value.length > 16) {
                    return value.slice(0, 16) + "...";
                }
                return value;
            }
        },
        methods: {
            cardClick(item, index) {
                this.current = index;
            },
            //获取分类
            getNewCatetoryList() {
                this.loading = true;
                this.$api.get('/api/web/get_newsCategories').then(res => {
                    this.loading = false;
                    this.selectList = res.response;
                    this.indexTitle = res.response[0].newsCategoryName;
                    this.getNewList(res.response[0].id)
                    this.selectList.forEach(function (item, index) {
                        if (index == 0) {
                            item.img = require('@/assets/3_enable.png')
                        }
                        if (index == 1) {
                            item.img = require('@/assets/1.png')
                        }
                        if (index == 2) {
                            item.img = require('@/assets/2.png')
                        }
                    });

                }).catch(() => {
                    this.loading = false;
                });
            },
            //获取合作伙伴
            getPartnerList() {
                ///api/web/get_partners
                this.loading = true;
                this.$api.get('/api/web/get_partners').then(res => {
                    this.loading = false;
                    this.partnerList = res.response;
                }).catch(() => {
                    this.loading = false;
                });
            },
            //获取公司信息
            getCompany() {
                this.$api.get('/api/web/company_info').then(res => {
                    this.company = res.response;
                    localStorage.setItem('companyInfo',JSON.stringify(this.company))
                })
            },
            //获取合作伙伴
            getHotProductList() {
                ///api/web/get_partners
                this.loading = true;
                this.$api.get('/api/web/get_hot_product_list').then(res => {
                    this.loading = false;
                    this.hotProductList = res.response.list
                    if(this.hotProductList.length != 0){
                        this.hotProductList.forEach(e =>{
                           e.productLogo = this.imageUrl + e.productLogo 
                        })
                    }
                    //this.partnerList = res.response;
                }).catch(() => {
                    this.loading = false;
                });
            },
            //获取新闻列表的
            getNewList(categoryId){
                 this.$api.get('/api/web/get_news_page_list',{
                     categoryId:categoryId,
                     pageNum:1,
                     pageSize:10
                 }).then(res => {
                    this.newList = res.response.list

                }).catch(() => {

                });        
            },
            selectClick(i, item) {
                this.activeClick = i
                //先将所有的值恢复
                var list = this.selectList;
                if(this.langes == 0){
                    this.indexTitle = list[i].newsCategoryName;
                }else{
                    this.indexTitle = list[i].newsCategoryNameEn;
                }
            
                 this.getNewList(list[i].id)
                list.forEach(function (item, index) {
                    if(index == 0){
                      item.img = require('@/assets/3.png');      
                    }
                    if(index == 1){
                        item.img = require('@/assets/1.png');
                    }
                    if(index == 2){
                        item.img = require('@/assets/2.png')
                    }
                });
                list.forEach(function (item, index) {
                    if (i == 0 && index == 0) {
                        item.img = require('@/assets/3_enable.png');
                    }else if(i == 1 && index == 1){
                        item.img = require('@/assets/1_enable.png');
                    }else if(i == 2 && index == 2){
                         item.img = require('@/assets/2_enable.png')
                    }
                });
                this.selectList = list
            },
            findMoreClick(){
                //查看更多
                this.$emit('findMoreClick')
            },
            findCompanyInfoClick(){
                //查看公司详情
                this.$emit('findCompanyInfo')
            },
            hotProductClick(){
                //查看热门产品
                this.$emit("hotProductClick")
            },
             // 获取广告图
            getLeftImg() {
                this.$api.get('/api/web/home_advert',
                {
                    position:"left_index"
                }).then(res => {
                    this.leftUrl = res.response[0].advertPath
                    this.leftIndexUrl = this.imageUrl + res.response[0].advertImgPath
                })
            },
             // 获取广告图
            getRightImg() {
                this.$api.get('/api/web/home_advert',
                {
                    position:"right_index"
                }).then(res => {
                    this.rightUrl = res.response[0].advertPath
                    this.rightIndexUrl = this.imageUrl + res.response[0].advertImgPath
                })
            }


        }
    }
</script>

<style lang="less" scoped>
    .homes {
        height: calc(~"100% - 20px");
        .homesCard {
            margin: 30px auto;

            span {
                padding: 8px 28px;
                border: 1px solid #ccc;
                border-radius: 16px;
                font-size: 14px;
                margin-right: 20px;
                cursor: pointer;
            }

            .activeName {
                background: #2950b8;
                color: #fff;
                border: 0;
            }
        }

        .productCard {
            margin-top: 37px;
            width: 100%;
            height: 320px;
            margin-bottom: 37px;
        }

        .card {
            width: 230px;
            height: 320px;
        }

        .imageCard {
            width: 230px;
            height: 230px;
            display: block;
        }

        .IndexCard {
            width: 1100px;
            margin-bottom: 50px;
        }

        .el-aside {

            color: #333;
            text-align: center;
            line-height: 200px;
        }

        .el-main {
            background-color: #fff;
            color: #333;
            text-align: center;
            //line-height: 160px;
        }

        .home_select {
            width: 180px;
            height: 150px;
            background: #1E90FF;
        }

        .select {
            width: 180px;
            height: 150px;
            display: flex;
            justify-content: center;
            flex-flow: column;
            align-items: center;
            align-content: center;
            justify-items: center;
        }

        .enables {
            background: #015EB7;
        }

        .bottom {
            margin-top: 13px;
            line-height: 12px;
        }

        .clearfix:before,
        .clearfix:after {
            display: table;
            content: "";
        }

        .clearfix:after {
            clear: both
        }

        .contentSpan {
            color: white;
        }

        .contentSpan-disable {
            color: #015EB7;
        }

        .bg-purple {
            background: #d3dce6;
        }

        .bg-purple-light {
            background: #e5e9f2;
        }

        .grid-content {
            min-height: 451px;
        }

        .grid-content-l {
            min-height: 40px;
            height: 40px;
            background: white;
            display: flex;
            flex-direction: row;
            flex-flow: row;
            justify-content: flex-start;
            align-items: center;
            padding-left: 10px;
            padding-right: 10px;
        }
        .grid-content-imge{
             min-height: 200px;
        }
        .titleSpan{
            font-size: 15px;
            color: #333;

        }
        .titleInfoSpan{
            font-size: 12px;
            color: #999;     
        }
        .findMore{
            width: 30%;
            min-height: 40px;
            height: 40px;
            background: white;
            display: flex;
            color: #999;     
            flex-direction: row-reverse;
            flex-flow: row-reverse;
            justify-content: flex-start;
            align-items: center;
            cursor: default;
        }
        .content{
            display: flex;
            flex-direction: row;
            flex-flow: row;
            justify-content: flex-start;
            align-items: center; 
            color:#333;
            margin-top: 16px;
            font-size:14px;
        }

        .indexUL{
            width: 100%;
            background-color: white;
        }
        .indexLi{
            display: flex;
            flex-direction: row;
            flex-flow: row;
            justify-content: flex-start;
            align-items: center;
            list-style-type: disc;
            font-size: 18px;
            color: #999;
            margin-top: 5px;
            margin-bottom: 5px;
        }
        .contentSpanTitle{
            width:270px;
            display: flex;
            flex-direction: row;
            flex-flow: row;
            justify-content: flex-start;
            // overflow:hidden;
            // text-overflow:ellipsis;
            // white-space:nowrap;
            // word-break:keep-all;
            font-size: 15px;
        }
        .contentSpanTime{
            font-size: 12px;
            color: #999;
        }
        .findInfo{
            width: 30%;
            min-height: 40px;
            height: 40px;
            background: white;
            display: flex;
            color: #999;     
            flex-direction: row-reverse;
            flex-flow: row-reverse;
            justify-content: flex-start;
            align-items: center;
        }
        .companyInfo{
            width: 80%;
            display: flex;
            flex-direction: row;
            flex-flow: row;
            justify-content: flex-start;
            align-items: center;
        }


    }


</style>
